import { render, staticRenderFns } from "./AddDestinations.vue?vue&type=template&id=8d2624a0&"
import script from "./AddDestinations.vue?vue&type=script&lang=js&"
export * from "./AddDestinations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d2624a0')) {
      api.createRecord('8d2624a0', component.options)
    } else {
      api.reload('8d2624a0', component.options)
    }
    module.hot.accept("./AddDestinations.vue?vue&type=template&id=8d2624a0&", function () {
      api.rerender('8d2624a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/empresas/72235100-2/components/AddDestinations.vue"
export default component.exports